export default __webpack_public_path__ + "static/media/icon-done-grey.96916892.svg";